var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", width: "1000" },
      on: { "click:outside": _vm.close },
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "", color: "#fafafa" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "main", attrs: { flat: "", dark: "" } },
            [
              _c("v-toolbar-title", [_vm._v(" Generate Billing Reports ")]),
              _c("v-spacer"),
              _c(
                "v-col",
                { staticClass: "px-0", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", loading: _vm.submitting },
                      on: { click: _vm.close },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "mr-2 pl-2", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.submitting,
                        disabled:
                          _vm.selectedStatements.length === 0 ||
                          !_vm.fileGenChecked,
                      },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v(" Confirm ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-card-subtitle", { staticClass: "pb-0 pt-4" }, [
            _vm._v(
              " Select statements to include in aggregated invoices/reporting. "
            ),
          ]),
          _c(
            "v-form",
            { ref: "form", attrs: { "lazy-validation": "" } },
            [
              _c(
                "v-container",
                { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-container",
                    { staticClass: "ma-0 pa-2", attrs: { fluid: "" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "grid",
                            "grid-auto-flow": "column",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "align-center d-flex ml-3" },
                            [
                              _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "4" } },
                                [
                                  _c("v-autocomplete", {
                                    staticStyle: {
                                      height: "40px",
                                      "border-top-right-radius": "0",
                                      "border-bottom-right-radius": "0",
                                    },
                                    attrs: {
                                      dense: "",
                                      solo: "",
                                      flat: "",
                                      outlined: "",
                                      placeholder: "Search By",
                                      items: _vm.searchParams,
                                      "item-text": "description",
                                      "return-object": "",
                                      "menu-props": {
                                        maxHeight: 260,
                                        rounded: "",
                                      },
                                    },
                                    model: {
                                      value: _vm.search.key,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.search, "key", $$v)
                                      },
                                      expression: "search.key",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "4" } },
                                [
                                  _vm.showDateField
                                    ? [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              transition: "scale-transition",
                                              "max-width": "290px",
                                              "min-width": "290px",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticStyle: {
                                                                height: "40px",
                                                                "border-radius":
                                                                  "0",
                                                              },
                                                              attrs: {
                                                                dense: "",
                                                                solo: "",
                                                                flat: "",
                                                                outlined: "",
                                                                placeholder:
                                                                  "Search By " +
                                                                  _vm.search.key
                                                                    .description,
                                                                value:
                                                                  _vm.formattedDate,
                                                                readonly: "",
                                                              },
                                                              on: {
                                                                keydown:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      !$event.type.indexOf(
                                                                        "key"
                                                                      ) &&
                                                                      _vm._k(
                                                                        $event.keyCode,
                                                                        "enter",
                                                                        13,
                                                                        $event.key,
                                                                        "Enter"
                                                                      )
                                                                    ) {
                                                                      return null
                                                                    }
                                                                    return _vm.searchStatements.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-text-field",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3478623992
                                            ),
                                            model: {
                                              value: _vm.batch_dt_picker,
                                              callback: function ($$v) {
                                                _vm.batch_dt_picker = $$v
                                              },
                                              expression: "batch_dt_picker",
                                            },
                                          },
                                          [
                                            _c("v-date-picker", {
                                              attrs: { "no-title": "" },
                                              on: {
                                                input: function ($event) {
                                                  _vm.batch_dt_picker = false
                                                },
                                              },
                                              model: {
                                                value: _vm.search.value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression: "search.value",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    : [
                                        _c("v-text-field", {
                                          staticStyle: {
                                            height: "40px",
                                            "border-radius": "0",
                                          },
                                          attrs: {
                                            dense: "",
                                            solo: "",
                                            flat: "",
                                            outlined: "",
                                            placeholder: _vm.search.key
                                              ? "Search By " +
                                                _vm.search.key.description
                                              : "Select Search Field",
                                            disabled: !_vm.search.key,
                                            clearable: "",
                                          },
                                          on: {
                                            keydown: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.searchStatements.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                            "click:clear": _vm.clearSearch,
                                          },
                                          model: {
                                            value: _vm.search.value,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.search, "value", $$v)
                                            },
                                            expression: "search.value",
                                          },
                                        }),
                                      ],
                                ],
                                2
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0", attrs: { cols: "1" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        height: "40px",
                                        "border-top-left-radius": "0",
                                        "border-bottom-left-radius": "0",
                                        border: "1px solid #9e9e9e",
                                        "border-left": "0px",
                                      },
                                      attrs: {
                                        dense: "",
                                        depressed: "",
                                        loading: _vm.searching,
                                        disabled:
                                          !_vm.search.key || !_vm.search.value,
                                        color: "primary",
                                      },
                                      on: { click: _vm.searchStatements },
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v(_vm._s("mdi-magnify")),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "grid",
                                "grid-auto-flow": "column",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "my-auto",
                                    attrs: {
                                      label: "Admin",
                                      "hide-details": "",
                                      disabled:
                                        _vm.vendorFileChecked ||
                                        _vm.retailerFileChecked,
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.adminFileChecked,
                                      callback: function ($$v) {
                                        _vm.adminFileChecked = $$v
                                      },
                                      expression: "adminFileChecked",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "my-auto",
                                    attrs: {
                                      label: "Retailer",
                                      "hide-details": "",
                                      disabled: _vm.adminFileChecked,
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.retailerFileChecked,
                                      callback: function ($$v) {
                                        _vm.retailerFileChecked = $$v
                                      },
                                      expression: "retailerFileChecked",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "my-auto",
                                    attrs: {
                                      label: "Vendor",
                                      "hide-details": "",
                                      disabled: _vm.adminFileChecked,
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.vendorFileChecked,
                                      callback: function ($$v) {
                                        _vm.vendorFileChecked = $$v
                                      },
                                      expression: "vendorFileChecked",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("v-divider"),
                  _c("v-data-table", {
                    directives: [
                      {
                        name: "ripple",
                        rawName: "v-ripple",
                        value: false,
                        expression: "false",
                      },
                    ],
                    style: { position: "relative", "z-index": "1" },
                    attrs: {
                      dense: "",
                      "items-per-page": _vm.pageSize,
                      headers: _vm.headers,
                      height: _vm.tableSize,
                      loading: _vm.loading,
                      items: _vm.statements,
                      "sort-by": _vm.sortBy,
                      "sort-desc": true,
                      "show-select": "",
                      "item-key": "id",
                      "fixed-header": "",
                      "hide-default-footer": "",
                    },
                    on: {
                      "update:itemsPerPage": function ($event) {
                        _vm.pageSize = $event
                      },
                      "update:items-per-page": function ($event) {
                        _vm.pageSize = $event
                      },
                      "update:items": function ($event) {
                        _vm.statements = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.batch_start_date",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formatDate(item.batch_start_date))
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.batch_end_date",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formatDate(item.batch_end_date))
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.updated_on",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formatDateTime(item.updated_on))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.selectedStatements,
                      callback: function ($$v) {
                        _vm.selectedStatements = $$v
                      },
                      expression: "selectedStatements",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-toolbar",
                { attrs: { flat: "", color: "#fafafa" } },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center", justify: "end" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticStyle: { "max-width": "150px" },
                          attrs: { cols: "2" },
                        },
                        [
                          _c("v-select", {
                            staticClass: "mt-8",
                            attrs: {
                              dense: "",
                              items: _vm.pageSizes,
                              label: "Items Per Page",
                              select: "",
                              "menu-props": {
                                top: true,
                                offsetY: true,
                                maxHeight: 500,
                              },
                            },
                            model: {
                              value: _vm.pageSize,
                              callback: function ($$v) {
                                _vm.pageSize = $$v
                              },
                              expression: "pageSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.disablePrevious,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.previous()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                        1
                      ),
                      _c("small", [_vm._v("Page " + _vm._s(_vm.page))]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-2",
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.disableNext,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.next()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "430", persistent: "" },
          model: {
            value: _vm.showConfirm,
            callback: function ($$v) {
              _vm.showConfirm = $$v
            },
            expression: "showConfirm",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pl-5 pr-2 pt-4 pb-2" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "warning" } },
                    [_vm._v("mdi-alert")]
                  ),
                  _c("div", { staticClass: "title h6" }, [_vm._v(" Confirm ")]),
                  _c(
                    "v-card-subtitle",
                    {
                      staticClass: "py-2 pl-0 pr-2 ma-0",
                      staticStyle: { "word-break": "break-word" },
                    },
                    [
                      _c("p", [
                        _vm._v(" You've selected: "),
                        _c("strong", [_vm._v(_vm._s(_vm.warningFileTypes))]),
                        _vm._v(
                          ". For the selected statements, the following reports will be generated and published to Documents Portal: "
                        ),
                      ]),
                      _c("p", [
                        _c(
                          "ul",
                          _vm._l(_vm.fileDocList, function (filename, i) {
                            return _c("li", { key: i }, [
                              _vm._v(" " + _vm._s(filename) + " "),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _vm.vendorFileChecked
                        ? _c(
                            "div",
                            { staticStyle: { "margin-top": "25px" } },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    text: "",
                                    type: "error",
                                    border: "left",
                                  },
                                },
                                [
                                  _c("p", { staticClass: "my-auto" }, [
                                    _c("strong", [
                                      _vm._v(
                                        "Warning: This action will load vendor invoices into Quickbooks."
                                      ),
                                    ]),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("p", [_vm._v("Continue?")]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey darken-1", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showConfirm = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    { attrs: { color: "warning" }, on: { click: _vm.submit } },
                    [_vm._v(" Continue ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }